import type { FaireProductEntity } from "../../entity_types/product";

export const p_cbcwemjws4: FaireProductEntity = {
  token: "p_cbcwemjws4",
  type: "product",
  name: 'Coarse Texture Planter-5"H',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/4f36b1d6d4d50674e47abc5330aec5fd88aee0e0fbab13bcb27fa3e905a5f34d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/30a154b97be3cf8b7c46bafe2abfd80c5da12cb633ca0773be8ed6be69ef5209.jpeg",
    "https://cdn.faire.com/fastly/82e03b0ddb21a2868d2eb32d1cdad66e90062a6880bbb148ab14ec8f4a76c2df.jpeg",
    "https://cdn.faire.com/fastly/3fc358d6a5aeddd9ddaf00cbf58c55cdf9e35cd840941069042b8955cbd075df.jpeg",
    "https://cdn.faire.com/fastly/2dbf7466f5ad75aa9cd0c0b37b3b9c55d8f50744d1ff1fcc8e198aa16fd0b68c.jpeg",
    "https://cdn.faire.com/fastly/37ce0b358c3f405c7185be720389c38973b6ce72a78989533b972763ff04abd1.jpeg",
    "https://cdn.faire.com/fastly/2931309941e4c2eee3db70030b8cd691130349afa0dd1c58d7b31dcc7ad86245.jpeg",
    "https://cdn.faire.com/fastly/6be0fe80804e689204cd607cfb043f294a9cf26b0dcabd886bb4c2bb51774ae1.jpeg",
    "https://cdn.faire.com/fastly/a59718f0cc2a9c72f7290c31f8e26be4bccd41372f8c19111ef5e688b700820e.jpeg",
    "https://cdn.faire.com/fastly/69bfcd61f37faae984fba81847e780b58d38588c147890e6abc144b1515092c8.jpeg",
  ],
  priceDollars: 7.5,
  description:
    "Crafted from stoneware with a rugged finish, this beige planter is equal parts structure and style. Ideal for indoor foliage with a modern edge.",
  tags: [],
  msrpDollars: 15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:05.754Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
